"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateOverrideValueSources = exports.RateOverrideValueSource = void 0;
var RateOverrideValueSource;
(function (RateOverrideValueSource) {
    RateOverrideValueSource["Field"] = "field";
    RateOverrideValueSource["Value"] = "value";
})(RateOverrideValueSource = exports.RateOverrideValueSource || (exports.RateOverrideValueSource = {}));
exports.RateOverrideValueSources = Object.values(RateOverrideValueSource);
//# sourceMappingURL=rate-override-value-source.js.map